<template>
  <div class="container">
    <div class="tabBar" v-if="tabBarConfig && tabBarConfig.length > 1">
      <div
        class="tabItem"
        v-for="tabBarItem in tabBarConfig"
        :class="{ active: currentActiveTabId === tabBarItem.rewardType }"
        :key="tabBarItem.key"
        @click="handleTabBarClick(tabBarItem.rewardType)"
      >
        {{ tabBarItem.title }}
      </div>
    </div>
    <TabContainer
      :value="currentActiveTabId"
      class="tabContainer"
      v-if="tabBarConfig && tabBarConfig.length > 1"
    >
      <TabContainerItem
        :id="tabBarItem.rewardType"
        :key="tabBarItem.rewardType"
        v-for="tabBarItem in tabBarConfig"
      >
        <component
          :awardsList="tabData"
          :cashData="cashData"
          :cashType="cashType"
          @success="taskCashSuccess"
          :is="tabBarItem.contentComp"
        ></component>
      </TabContainerItem>
    </TabContainer>
    <component
      v-if="tabBarConfig && tabBarConfig.length === 1"
      :awardsList="tabData"
      :cashData="cashData"
      :cashType="cashType"
      @success="taskCashSuccess"
      :is="tabBarConfig[0].contentComp"
    ></component>
    <div class="empty" v-if="tabBarConfig && tabBarConfig.length == 0">
      <p>您还没有任何奖励哦～</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { TabContainer, TabContainerItem } from 'mint-ui';
import AwardsList from '../components/myAwards/AwardsList';
import { getRewardTypes, getRewardData } from '../api';
import CashPack from '../components/myAwards/CashPack';
import { TAB_REWARD_TYPE } from '../constants';
import { getUrlParam } from '@/utils';
import { getBusiness, isXL } from '../utils/index';
const TabBarComponentBook = {
  [TAB_REWARD_TYPE.AWARDS]: {
    key: 'awards',
    contentComp: AwardsList
  },
  [TAB_REWARD_TYPE.CASH_PACK]: {
    key: 'cashPack',
    contentComp: CashPack
  }
};

export default {
  components: {
    TabContainer,
    TabContainerItem,
    AwardsList,
    CashPack
  },
  data() {
    return {
      tabBarConfig: null,
      currentActiveTabId: 0,
      cashData: {},
      tabData: []
    };
  },
  computed: {
    ...mapState('app', ['actData']),
    cashType() {
      let appText = isXL() ? '小拉' : '';
      return this.actData && this.actData.takeCashType == 0
        ? '微信零钱'
        : `${appText}司机App钱包余额`;
    }
  },
  async created() {
    if (getUrlParam('u')) {
      let userType = getUrlParam('u') === '1' ? 'user' : 'driver';
      this.set_env(userType);
    }
    await this.loadLocationData(true);
    if (!this.actData.metaInfo) {
      try {
        await this.fetchPageInfo();
      } catch (error) {
        this.$hll.toast(error && error.msg);
        return;
      }
    }
    this.getRewardTypes();
    this.trackLog('我的奖励', false, {
      business_line: null,
      actEventType: 'invite_reward_expo',
      activity_business: getBusiness(this.actData.businessLine)
    });
  },
  methods: {
    ...mapActions('app', ['loadLocationData', 'fetchPageInfo']),
    ...mapMutations('global', ['set_env']),
    getRewardTypes() {
      getRewardTypes().then(res => {
        let arr = res.map(item => {
          return { ...item, ...TabBarComponentBook[item.rewardType] };
        });
        this.tabBarConfig = Array.isArray(arr) ? arr : [];
        if (this.tabBarConfig.length === 1) {
          this.getRewardData(arr[0].rewardType);
          this.currentActiveTabId = arr[0].rewardType;
          return;
        }
        arr.length >= 1 && this.handleTabBarClick(arr[0].rewardType);
      });
    },
    getRewardData(rewardType) {
      getRewardData({ rewardType }).then(res => {
        this[res.rewardType == 5 ? 'cashData' : 'tabData'] = res;
      });
    },
    taskCashSuccess() {
      this.getRewardData(this.currentActiveTabId);
    },
    handleTabBarClick(value) {
      if (value == this.currentActiveTabId) return;
      this.currentActiveTabId = value;
      this.getRewardData(value);
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  background: #f3f4f5;

  .empty {
    margin: 30px auto 0;
    .fc;
    padding-top: 50px;
    padding-bottom: 50px;
    width: 702px;
    height: 168px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.09);
    p {
      font-size: 30px;
      color: #8c8c8c;
    }
  }
}
.tabBar {
  width: 100%;
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: space-between;

  &:before,
  &:after {
    content: '';
    display: block;
  }

  .tabItem {
    box-sizing: border-box;
    height: 100%;
    display: flex;
    align-items: center;
    line-height: normal;
    font-size: 30px;
    color: #000;

    &.active {
      color: #ff6600;
      border-bottom: 4px solid #ff6600;
    }
  }
}

.tabContainer {
  width: 100%;
  height: calc(100vh - 80px);
  overflow-y: auto;
}
</style>
